export default __webpack_public_path__ + "static/media/3.993a2b47.svg";